import cloudinary from 'cloudinary-core';

const CLOUDINARY_CLOUD_NAME = 'letsdothiscom';
const CLOUDINARY_URL_PREFIX = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/`;

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_CLOUD_NAME,
  secure: true,
});

export const isCloudinaryUploadUrl = (url) => {
  return !!url?.startsWith(CLOUDINARY_URL_PREFIX);
};

export const parseCloudinaryUrl = (url) => {
  // This function attempts to parse various parts of the Cloudinary URL.

  // Asset delivery URL takes the following structure:
  // https://res.cloudinary.com/<cloud_name>/<resource_type>/<type>/<transformations>/<version>/<public_id>.<format>
  // See: https://cloudinary.com/documentation/image_transformations#transforming_media_assets_using_dynamic_urls

  // However, it's not recommended that you do this.
  // TODO: it's recommended that you save Cloudinary objects instead of full URLs
  // https://github.com/cloudinary/cloudinary_js/issues/94#issuecomment-585172563

  const versionIndex = url.indexOf('/v');
  const urlFromVersion = url.substr(versionIndex + 1);
  const publicIdIndex = urlFromVersion.indexOf('/') + 1;

  // Doesn't attempt to remove (optional) format, e.g. ".jpg"
  const publicId = urlFromVersion.substr(publicIdIndex);
  const version = urlFromVersion.substring(1, publicIdIndex - 1);

  return {
    publicId,
    version,
  };
};

export const transformUrl = (imageUrl, transformations) => {
  if (!isCloudinaryUploadUrl(imageUrl)) return imageUrl;
  const { publicId, version } = parseCloudinaryUrl(imageUrl);
  return cl.url(publicId, { version, ...transformations });
};

export const generateImageSrcSetString = (
  url,
  widths,
  defaultTransformations,
) => {
  const transformations = defaultTransformations || {
    fetchFormat: 'auto',
    quality: 'auto',
    crop: 'fit',
    dpr: 'auto',
  };
  return widths
    .map(
      (width) =>
        `${transformUrl(url, {
          ...transformations,
          width,
        })} ${width}w`,
    )
    .join(', ');
};
